import { useNavigate, Link } from "react-router-dom";
import { COLORS } from "../theme/theme.config";
import { useEffect } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import React from "react";

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <CheckCircleOutlineIcon style={styles.icon} />
        <h2 style={styles.heading}>Your purchase was successful</h2>
        <p style={styles.text}>
          You're all set! Your subscription is now activated.
        </p>
        <p style={styles.text}>
          You’ll be redirected in 10 seconds. If you want to redirect now, click
          the button below.
        </p>

        <Link to="/" style={styles.link}>
          Get Started
        </Link>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f9f9f9",
    padding: "20px",
  },
  content: {
    textAlign: "center",
    maxWidth: "500px",
    padding: "30px",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
  },
  icon: {
    color: COLORS.green,
    fontSize: "48px",
    marginBottom: "10px",
  },
  heading: {
    fontSize: "24px",
    marginBottom: "16px",
    color: "#333",
    fontWeight: "bold",
  },
  text: {
    fontSize: "16px",
    marginBottom: "12px",
    color: "#555",
  },
  link: {
    marginTop: "10px",
    display: "inline-block",
    color: "#fff",
    backgroundColor: COLORS.primary,
    padding: "10px 20px",
    borderRadius: "4px",
    textDecoration: "none",
    fontWeight: "bold",
    fontSize: "14px",
  },
};

export default ThankYou;
